export default __webpack_public_path__ + "assets/images/result-4b11a39db00fdd8111cfdc911240fe71.jpg";